import React from 'react'
import SubHeader from '../general/SubHeader';
import Face1 from '../assets/product/face1.webp';
import Face2 from '../assets/product/face2.webp';

const FaceAttendance = () => {
  return (
    <>
      <SubHeader message='Face Attendance' />

      <section className='my-5'>
        <div className='container'>

          <div className='row'>

            <div className='col-lg-8 col-12'>
              <img src={Face1} className='img-fluid col-6' alt='Billing Software' />
              <img src={Face2} className='img-fluid col-6' alt='Billing Software' />
              <p className='sec-heading mt-4'>Dectwin Face Attendance Software</p>
              <p className='text-muted'>The Dectwin Face Attendance Application revolutionizes workforce management with face & location
                capture feature. Our face application providers in Prayagraj
                offer this face app service for seamless, contactless attendance tracking, ensuring accuracy and security. Ideal for
                modern businesses, it eliminates manual errors, and ensures a smooth, user-friendly experience.</p>

              <div className='bg-light rounded-3 px-3 py-3 my-3'>
                <p className='banner-subheading'>Face Attendance Application for Mobile/ Android</p>
                <p className='text-muted'>The Face Attendance Application is a cutting-edge solution for modern workforce management,
                utilizing advanced facial recognition and GPS technology. Our Dectwin face attendance app services in Allahabad streamlines staff check-in/out processes while ensuring accuracy and accountability. The app captures facial data and location to prevent time fraud and enhance security. With features like monthly payslip downloads and automated record management, it simplifies administrative tasks, boosts transparency, and ensures seamless attendance tracking for organizations of all sizes.</p>
              </div>

              <div className='bg-light rounded-3 px-3 py-3'>
                <p className='banner-subheading'>Dectwin Face Attendance App Features</p>
                <p className='text-muted'><strong> Multiple Location Staff Management</strong> Effortlessly manage employees across multiple locations with our Face Attendance Application. Track attendance, location, and schedules seamlessly, ensuring synchronized operations and consistent reporting, regardless of where your staff is located.<br /><br />
              <strong>Manual Attendance</strong> The application allows administrators to manually mark or edit attendance records, ensuring accuracy and flexibility. Whether correcting errors or adding special exceptions, this feature empowers managers to maintain reliable records without disrupting the overall attendance tracking process.<br /><br />
              <strong>Advance Salary Amount Management</strong> Manage advance salary requests efficiently with a built-in system. This feature tracks, approves, and integrates advance payments with payroll processing, ensuring transparency and reducing administrative burden, while meeting employee needs promptly and professionally.<br /><br />
              <strong>Know Star Performer of the Month</strong> Recognize top-performing employees with our software’s star performer feature. By analyzing attendance and punctuality records, the system identifies individuals with maximum presence, promoting fairness and rewarding dedication, boosting overall workplace morale and productivity.</p>

              </div>

            </div>

            <div className='col-lg-4 col-12 my-2'>
                                                        <div className='bg-light px-3 py-4 rounded-3 mb-3'>
                                <p className='fw-bold fs-5'>Get Demo of E Attendance App</p>
                                <button className='banner-btn1' onClick={() => window.open('https://wa.me/8707510135?text=Hey!%20Dectwin%20Services.%20I%20want%20demo%20of%20Dectwin%Attendance%20App.', '_blank')}>Get Free DEMO Now</button>
                                </div>              <div className='bg-light px-3 py-4 rounded-3'>
                <p className='fw-bold fs-5'>Product Information</p>

                <div className='contact-area mb-3'>
                  <i class="fa-solid contact-icon fa-check-to-slot"></i>
                  <div>
                    <p className='fw-semibold my-0'>Staff Check In/Out</p>
                    <p className='para-text text-muted'>Enables accurate and hassle-free staff check-in and check-out</p>
                  </div>
                </div>

                <div className='contact-area mb-3'>
                  <i class="fa-solid contact-icon fa-face-smile"></i>
                  <div>
                    <p className='fw-semibold my-0'>Face & Location Capture</p>
                    <p className='para-text text-muted'>Logs attendance with precise details of an employee’s physical presence and location capture for enhanced
                    security</p>
                  </div>
                </div>

                <div className='contact-area mb-3'>
                  <i class="fa-solid contact-icon fa-receipt"></i>
                  <div>
                    <p className='fw-semibold my-0'>Monthly Payslip Download</p>
                    <p className='para-text text-muted'>Access and download the detailed salary slips with ease</p>
                  </div>
                </div>

                <img src={Face2} className='img-fluid mt-3' alt='Billing Software' />
              </div>

            </div>
            {/* right ends */}

          </div>
          {/* row ends */}

        </div>
      </section>


{/* Pricing Section */}
<section className='my-5'>
  <div className='container text-center'>

  <div className='sec-heading text-capitalize'>Plans & Pricing</div>

<div className='row mt-4 justify-content-center'>

<div className='my-2 col-lg-4 col-md-6 col-12'>

<div className='pricing-outer'>
<div className='pricing-inner'>
  <h5 className='text-uppercase'>First Purchase</h5>
  <div className='sec-heading'>₹ 4999/-</div>
  <h5 className='mt-3'><span className='text-red'><i class="fa-solid fa-tags fa-flip-horizontal"></i> Sale</span> <span className='text-decoration-line-through'>₹ 8,000</span></h5>
</div>

<div className='bg-light px-4 py-4 text-muted'>
  <h6>Android, Mobile</h6>
  <hr />
  <h6>Manage Staff/ Employees</h6>
  <hr />
  <h6>Monthly Payslip</h6>
  <hr />
  <h6>Ease of Attendance</h6>
  <hr />
  <h6>Face/ Location Capture</h6>
  <hr />
  <h6>Advance Salary Records</h6>
</div>

</div>
{/* pricing outer ends */}
</div>
{/* column ends */}


<div className='my-2 col-lg-4 col-md-6 col-12'>

<div className='pricing-outer'>
<div className='pricing-inner'>
  <h5 className='text-uppercase'>Yearly AMC</h5>
  <div className='sec-heading'>₹ 2999/-</div>
  <h5 className='mt-3'><span className='text-red'><i class="fa-solid fa-tags fa-flip-horizontal"></i> Sale</span> <span className='text-decoration-line-through'>₹ 5,000</span></h5>
</div>

<div className='bg-light px-4 py-4 text-muted'>
  <h6>Annual Software Maintenance</h6>
  <hr />
  <h6>Regular Updates</h6>
  <hr />
  <h6>1 Year Plan Recharge</h6>
  <hr />
  <h6>Technical Support</h6>
  <hr />
  <h6>Online Assistance</h6>
  <hr />
  <h6>Minor Customizations</h6>
</div>

</div>
{/* pricing outer ends */}
</div>
{/* column ends */}


</div>
{/* row ends */}

  </div>
</section>
{/* Pricing Section ends */}



    </>
  )
}

export default FaceAttendance
